function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTweetWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Zm4.94,8.43v.31a6.8,6.8,0,0,1-10.49,5.74,2.83,2.83,0,0,1,.57,0,4.78,4.78,0,0,0,3-1,2.39,2.39,0,0,1-2.24-1.67,2.28,2.28,0,0,0,1.07,0,2.39,2.39,0,0,1-1.92-2.35h0a2.35,2.35,0,0,0,1.09.3,2.4,2.4,0,0,1-.74-3.2A6.78,6.78,0,0,0,16.2,15a2.39,2.39,0,0,1,4.07-2.18,4.77,4.77,0,0,0,1.56-.6,2.41,2.41,0,0,1-1.06,1.33,5,5,0,0,0,1.38-.38,4.68,4.68,0,0,1-1.23,1.24Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweetWhite);
export default __webpack_public_path__ + "static/media/tweet-white.f933282b.svg";
export { ForwardRef as ReactComponent };